import type { ReactNode } from 'react';

/** Abschnitt in den Einstellungen mit Überschrift. */
export function Panel({ title, children }: { readonly title: string; readonly children: ReactNode }) {
  return (
    <section className="mb-4 rounded-card border border-border-subtle bg-surface-raised p-4">
      <h2 className="mb-3 font-semibold">{title}</h2>
      {children}
    </section>
  );
}
